export default __webpack_public_path__ + "static/line3-d564c093f2113109a17f8683bdbf4a2b.webp";